<ng-template #footerButtons>
  <div class="flex flex--start flex--row-reverse">
    <fcom-button
      data-testid="filters-modal-primary-button"
      class="ms-small-l"
      [theme]="primaryFooterButtonTheme()"
      [text]="primaryFooterButtonTitle()"
      (clickBtn)="onPrimaryButtonClick()"
    />
    <fcom-button
      data-testid="filters-modal-secondary-button"
      [text]="secondaryFooterButtonTitle()"
      [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
      (clickBtn)="onSecondaryButtonClick()"
    />
  </div>
</ng-template>

<ng-template #filterBody>
  @if (filterContent()) {
    <ng-container *ngTemplateOutlet="filterContent()" />
  }
  @if (displayNotification()) {
    <fcom-notification
      data-testid="fcom-filters-popover-notification"
      [theme]="NotificationTheme.WARNING"
      [excludeColumns]="true"
      [iconCategory]="IconLibrary.SVG_LIBRARY"
      [iconName]="SvgLibraryIcon.INFO_BLOCK"
      [scale]="NotificationScale.SMALL"
    >
      <span>{{ notificationContent() }}</span>
    </fcom-notification>
  }
  <div class="ps-medium-y">
    <ng-container *ngTemplateOutlet="footerButtons" />
  </div>
</ng-template>

<div data-testid="fcom-filters-mobile">
  <button
    class="filters-button flex flex--no-wrap flex--center rounded-medium width--100 font-body-1 font-body-medium white-bg surface-primary border nordic-blue-400-border border-formfields"
    [ngClass]="{
      'medium-type': true,
      'pr-xxsmall-x': !isMobile(),
      'has-filtering': hasFiltering(),
    }"
    [disabled]="disabled()"
    fcomPopover
    [content]="filterBody"
    [options]="popoverOptions()"
    [enablePopover]="usePopover()"
    (closeClick)="onPopoverClose()"
    (popoverClosed)="onPopoverClose()"
    (click)="onButtonClick()"
  >
    @if (isMobile() || !dropdownVisual()) {
      <fcom-icon class="icon-small ms-xxsmall-l flex flex--self-center" [name]="SvgLibraryIcon.FILTER_OPTIONS" />
    }
    <span class="ms-xxsmall-l ps-small-y flex">
      {{ buttonText() }}
      @if (isMobile() || (!dropdownVisual() && hasFiltering())) {
        <span
          class="ms-xxsmall-l font-body-2 font-body-small flex flex--self-center nordic-blue-900-bg white-text dot surface-contrast text-icon-reversed"
        >
          {{ numberToShowWhenFiltered() }}
        </span>
      }
    </span>
    @if (!isMobile() && dropdownVisual()) {
      <fcom-icon
        class="icon-small ms-xxsmall-l flex flex--self-center"
        [name]="isModalOpen() ? SvgLibraryIcon.CHEVRON_UP : SvgLibraryIcon.CHEVRON_DOWN"
      />
    }
  </button>

  <fcom-modal
    [fullHeight]="!isMobileOrTablet()"
    [title]="modalTitle()"
    [open]="isModalOpen() && !usePopover()"
    (close)="filtersClose.emit()"
    [fitToContent]="true"
    [buttons]="ModalButtons.CUSTOM"
    data-testid="fcom-filters-mobile-modal-content"
  >
    @if (filterContent()) {
      <ng-container *ngTemplateOutlet="filterContent()" />
    }
    @if (displayNotification()) {
      <fcom-notification
        data-testid="fcom-filters-modal-notification"
        messageBox
        [theme]="NotificationTheme.WARNING"
        [excludeColumns]="true"
        [iconCategory]="IconLibrary.SVG_LIBRARY"
        [iconName]="SvgLibraryIcon.INFO_BLOCK"
        [scale]="NotificationScale.SMALL"
      >
        <span> {{ notificationContent() }}</span>
      </fcom-notification>
    }
    <div buttons>
      <ng-container *ngTemplateOutlet="footerButtons" />
    </div>
  </fcom-modal>
</div>
